import "./WorkFlowListing.scss";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ApiService from "../../services/apiService";
import { URL } from "url";
import URLS from "../../urls/Urls";
import { WorkFlowListItem } from "../../models/Workflow";
import { Dayjs } from "dayjs";
import { formatDate } from "../../utils/Helper";
import { useSelector } from "react-redux";
import { userDetails } from "../../redux/user/userSelector";

const WorkFlowListing: React.FC = () => {
  const user = useSelector(userDetails);
  const navigate = useNavigate();
  const [tab, setTab] = useState("DRAFT");
  const [page, setPage] = useState(1);
  const [activeWorkFlow, setActiveWorkFlow] = useState(false);
  const [list, setList] = useState<WorkFlowListItem[]>([]);
  const [totalPage, setTotalPage] = useState(1);

  useEffect(() => {
    getWorkFlows();
  }, [page, tab, activeWorkFlow]);

  const getWorkFlows = async () => {
    try {
      const { data } = await ApiService().client.get(URLS.WORKFLOW.LIST, {
        params: {
          tab,
          page,
          creator_id: activeWorkFlow ? user.id : null,
        },
      });
      if (data) {
        setList(data.workflows);
        console.log("Data: ", data.workflows);
        setTotalPage(data.total_pages);
      }
    } catch (error) {
      console.error("Error fetching workflow details");
    }
  };

  const handleNavigationToDetail = (id: number) => {
    navigate(`/workflows/${id}`);
  };

  const toggleWorkflow = () => {
    setActiveWorkFlow(!activeWorkFlow);
  };

  return (
    <div className="workflow-list-container full-width full-height overflow-hidden flex-column">
      <div className="upper-bar">
        <p className="xetgo-font-tag bold px-16 py-12">Workflows</p>
      </div>
      <div className="flex-1 flex-column px-16 py-12 gap-12">
        <div className="flex-row align-items-cennter justify-content-space-between">
          <div className="flex-row tab-container p-2">
            <p
              className={`xetgo-font-tag tab-option bold py-6 ${
                tab === "DRAFT" && "selected-tab"
              }`}
              onClick={() => setTab("DRAFT")}
            >
              Draft
            </p>
            <p
              className={`xetgo-font-tag tab-option bold py-6 ${
                tab === "PUBLISHED" && "selected-tab"
              }`}
              onClick={() => setTab("PUBLISHED")}
            >
              Published
            </p>
          </div>
          <div className="flex-row alignn-items-center gap-8">
            <div
              onClick={toggleWorkflow}
              className={`my-workflow-container xetgo-font-tag bold flex-row align-items-center justify-content-center gap-4 p-6 cursor-pointer ${
                activeWorkFlow && "active-workflow-container"
              }`}
            >
              {!activeWorkFlow && (
                <div
                  className={`inactive-workflow-circle ${
                    activeWorkFlow && "active-workflow-circle"
                  }`}
                ></div>
              )}
              <span>My Workflows</span>
              {activeWorkFlow && (
                <div
                  className={`inactive-workflow-circle ${
                    activeWorkFlow && "active-workflow-circle"
                  }`}
                ></div>
              )}
            </div>
            <div
              onClick={() => navigate("/workflows/create")}
              className="create-btn px-18 py-6 flex-row align-items-center justify-content-center xetgo-font-tag cursor-pointer"
            >
              + Create
            </div>
          </div>
        </div>

        <div className="flex-1 list-container p-16">
          <div className="entry-container">
            <p
              className="header-option p-12 xetgo-font-tag"
              style={{ textAlign: "center" }}
            >
              #
            </p>
            <p className="header-option p-12 xetgo-font-tag">ID</p>
            <p className="header-option p-12 xetgo-font-tag">Name</p>
            <p className="header-option p-12 xetgo-font-tag">Owner</p>
            <p className="header-option p-12 xetgo-font-tag">Creation Date</p>
          </div>
          {list.map((item, index) => {
            return (
              <div
                className={`flex-row entry-container entries ${
                  index % 2 === 0 && "odd-row"
                }`}
                onClick={() => handleNavigationToDetail(item.id)}
                key={`item-index-${index}`}
              >
                <p
                  className="header-option p-12 xetgo-font-tag"
                  style={{ textAlign: "center" }}
                >
                  {index + 1}
                </p>
                <p className="header-option p-12 xetgo-font-tag">{item.id}</p>
                <p className="header-option p-12 xetgo-font-tag">{item.name}</p>
                <p className="header-option p-12 xetgo-font-tag">
                  {item.owner_name}
                </p>
                <p className="header-option p-12 xetgo-font-tag">
                  {formatDate(item.created_at)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WorkFlowListing;
